<template>
  <header>
    <slot></slot>
  </header>
</template>

<script>
  export default {
    name: "HeaderView",
  }
</script>

<style lang="scss" scoped>
  header {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 160px;
    background: #FFFFFF;
    border-radius: 20px;
    font-size: 50px;
    font-weight: 500;
    color: #333333;
    margin-bottom: 20px;
  }
</style>